import React from "react";

export default function index() {
  return (
    <section>
      <h1>Experiencia</h1>

      <h2>Instituto Mexicano del Seguro Social</h2>

      <h3>Médica Urgencióloga</h3>

      <h4>Marzo 2014 — Octubre 2021</h4>

      <p>Atención médica en el área de urgencias.</p>
      <p>Proporcionar evaluaciones físicas exhaustivas a los pacientes.</p>
      <p>Trabajo en equipo con enfermeras, personal radiológico y otros médicos especialistas.</p>
      <p>Brindar informe médico a los familiares.</p>
    </section>
  );
}
